import React, { FC, ReactNode } from 'react';

interface IComponentProps {
  content: ReactNode;
}

export const AuthCardFooter: FC<IComponentProps> = ({ content }) => {
  return <div className="text-controls color-dark-grey auth-card-footer">{content}</div>;
};
